/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
export default class Rank extends Model {
  activitySummary() {
    return Model.attribute('activitySummary').call(this);
  }
  rank() {
    return Model.attribute('rank').call(this);
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/Rank', Rank);